<template>
  <div class="wrapper">
    <div
      :class="['logo',isFold ? 'menuFold':'', isLibraryDetail ?'is-UnifiedContentLibrary':'' ]"
      :style="{
        'background-image': 'url('+$_syscfg.index_log+')',
        width: logoWidth + 'px'
      }"
      @click="goIndex()"></div>

    <div class="headline headline1" :class="[isLibraryDetail ?'is-UnifiedContentLibrary':'']">
      <div v-if="params.showLink" class="left">
        <div class="link" v-for="(link, linkindex) in links" :key="linkindex" @click="jumpLink(link)" v-show="link.show">
          <img v-if="link.icon" :src="link.icon" alt="icon">
          <span :class="[link.key]">
            {{link.name}}
          </span>
        </div>
      </div>
      <p class="pageTitle" v-else-if="!params.showLink && !isSearchResult && !showMulti">
        <span>{{pageTitle}}</span>
        <i v-if="statusName == '推送失败' || statusName == '审核中' || statusName == '已上线' || statusName == '未上线' || statusName == '待审核' || statusName == '已退回'" :class="{statusName: true, red: statusName == '推送失败' || statusName == '已退回', yellow: statusName == '待审核'}">{{statusName}}</i>
      </p>
      <ul class="multiSelect" v-else-if="showMulti">
        <li @click="resourceType('backConfirm')" :class="{on: $store.state.resourceType == 'backConfirm', red: icon.guihuanqueren}">归还确认</li>
        <li @click="resourceType('delay')" :class="{on: $store.state.resourceType == 'delay', red: icon.yanqishenpi}">延期审批</li>
        <li @click="resourceType('list')" :class="{on: $store.state.resourceType == 'list', red: false}">设备列表</li>
        <li @click="resourceType('delayStatic')" :class="{on: $store.state.resourceType == 'delayStatic', red: false}">逾期统计</li>
      </ul>
      <div v-else-if="!params.showLink && isSearchResult" class="searchInput">
        <input v-model="searchKeyWord1" @keydown.enter="searchStream" type="text">
        <p class="search">
          <img @click="searchStream" src="../assets/img/headline/search.png" alt="">
        </p>
      </div>
      <div class="centerFilter" v-if="showCenterFilter"><filterGlobalFilter ref="globalFilter" @globalfilter="keywordChange" /><div @click="filterBox" class="filterBtn"><img src="../assets/img/filter/filterOn.png" alt="">高级搜索</div></div>

      <!--   统一内容库列表头部  s -->
      <p class="pageTitle" style="position: absolute" v-if="unifiedPageTitle && !isLibraryDetail">
        <span>{{unifiedPageTitle}}</span>
      </p>
      <div id="library-search-container" v-if="unifiedPageTitle && !isLibraryDetail" style="flex:1; display: flex;justify-content: flex-end; margin-right: 30px;"></div>
      <!--   统一内容库列表头部  e -->


      <!--   统一内容库详情头部  s -->
      <div v-if="isLibraryDetail" class="headline-unified-content-library">
        <!-- <div class="unified-back" @click="handleUnifiedBack">
          <img src="@/assets/img/headline/unified-back.svg" alt="" />
        </div> -->
        <div class="unified-title">{{libraryDetailInfo.title}}</div>
        <div class="unified-operate" v-if="`${libraryDetailInfo.library_type}` === '0'">
          <div class="unified-operate-download" @click="handleUnifiedDownload"></div>
          <div class="unified-operate-jovone" @click="handleUnifiedJovone"></div>
          <div class="unified-operate-op" @click="handleUnifiedOp"></div>
        </div>
      </div>
      <!--   统一内容库详情头部  e -->

      <div class="right">
        <globalFilter ref="globalFilter" v-if="showFilter" />
        <div class="user" @mouseover.stop="toggleMenu(true)" @mouseout.stop="toggleMenu(false)">
          <div v-click-outside="closeAvatar" class="avatar-container">
            <img @error="imgError" @click="showAvatar=!showAvatar" :src="user.avatar" alt="avatar">
            <!-- <div v-show="showAvatar" class="avatar">
              <ul>
                <li @click="goMaterial">
                  <i class="materialIcon"></i>
                  <span>我的素材</span>
                </li>
                <li @click="goSet">
                  <i class="editIcon"></i>
                  <span>个人设置</span>
                </li>
                <li @click="quit">
                  <i class="closeIcon"></i>
                  <span>退出</span>
                </li>
              </ul>
            </div> -->
            <div v-show="showAvatar" class="newAvatar">
              <div class="platform">
                <p class="t">平台</p>
                <ul>
                  <li v-for="(item,index) in platformList" :key="item.product_id" :class="{on: index == 0}" @click="toThird(item, index)">{{item.title}}</li>
                </ul>
              </div>

              <div class="setBtn">
                <ul>
                  <li @click="goMaterial">
                    <i class="materialIcon"></i>
                    <span>我的素材</span>
                  </li>
                  <li @click="goSet">
                    <i class="editIcon"></i>
                    <span>个人设置</span>
                  </li>
                  <li @click="quit">
                    <i class="closeIcon"></i>
                    <span>退出</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div v-click-outside="closeUpload" class="upload-container" v-if="Object.keys(create).some(e=>create[e])"> -->
          <div v-click-outside="closeUpload" class="upload-container" v-show="create.interview || create.material || create.report || create.publish || create.new_media || create.tongyineirongku">
            <i title="创建" :class="{on: showUpload}" @click="showUpload=!showUpload"></i>
            <div v-show="showUpload" class="upload">
              <div></div>
              <ul>
                <li v-for="(item, index) in unifiedContentLibraryNewlyAppList" :key="index" @click="item.click && item.click()">
                  <i :class="item.icon"></i>
                  <span>{{item.title}}</span>
                </li>
                
                
                <li v-if="create.interview" @click="navigate('interview')">
                  <i class="interviewIcon"></i>
                  <span>新建采访</span>
                </li>
                <li v-if="create.material" @click="navigate('material')">
                  <i class="uploadIcon"></i>
                  <span>上传线索</span>
                </li>
                <li v-if="create.report" @click="navigate('report')">
                  <i class="reportIcon"></i>
                  <span>创建报道</span>
                </li>
                <li v-if="create.publish" @click="navigate('publish')">
                  <i class="publicIcon"></i>
                  <span>创建发布</span>
                </li>
                <li v-if="create.new_media" @click="navigate('new_media')">
                  <i class="newMediaPublicIcon"></i>
                  <span>新媒体发布</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-click-outside="closeStorage" v-if="quickEdit || quickCompose" class="storage-container">
            <i title="我的选用" :class="{on: showStorage}" @click="getQkList();showStorage = !showStorage"></i>
            <span :class="{on: Number(useNum) == 0, small: Number(useNum) < 10, middle: Number(useNum) > 9 && Number(useNum) < 100, big: useNum == '...'}">{{useNum}}</span>
            <div v-show="showStorage" class="storage">
              <div>
                <div class="title">
                  <p>我的选用<span>（拖动素材可以任意改变排序）</span></p>
                  <!-- <span>进入快编管理</span> -->
                </div>
                <div v-if="qkList.length == 0" class="empty">
                  <img src="../assets/img/common/newEmpty.png">
                  <p>还未添加任何选用素材哦</p>
                </div>
                <div v-if="qkList.length > 0" ref="qkContent" class="content">
                  <!-- <ul ref="qkDom">
                    <li :class="{lineOn: item.lineStatus}" draggable="true" :data-id="item.id" style="user-select: none" v-for="(item,index) in qkList" :key="index">
                      <i @click="singleSelect(index)" :class="{on: item.singleStatus,op: item.status == 0 || item.status == 3}"></i>
                      <div>
                        <div v-if="item.type-0 === 1" :style="{'background-image': `url(${item.cover || defaultImg})`}" class="bg">
                          <i v-if="item.type-0 === 2 || item.type-0 === 3" class="play"></i>
                        </div>
                        <div v-if="item.type-0 === 2 || item.type-0 === 3" :style="{'background-image': `url(${item.cover || defaultMedia})`}" class="bg">
                          <i class="play"></i>
                          <div v-if="item.status == 0 || item.status == 3" class="useMask">
                            <img v-if="item.status == 0" src="../assets/img/index/greenLoad.png" alt="">
                            <p v-if="item.status == 0" :style="'width:'+item.progress+'px'" class="line"></p>
                            <p v-if="item.status == 3" class="grey">转码失败</p>
                            <p @click="reRecode(item.id)" v-if="item.status == 3" class="green">重新转码</p>
                          </div>
                        </div>
                        <div @click="openDetail(index)" class="info">
                          <p>{{item.title}}</p>
                          <i :class="{video: item.type-0 === 2, pic: item.type-0 === 1, voice: item.type-0 === 3}"></i>
                        </div>
                      </div>
                      <img @click="delQk(item.id)" src="../assets/img/headline/bin.svg" alt="">
                    </li>
                  </ul> -->

                  <ul ref="qkDom">
                    <draggable
                      class="dragArea list-group"
                      :list="qkList"
                      :group="{ name: 'comp', pull: 'clone', put: false }"
                      @change="log"
                    >
                    <li :class="{lineOn: item.lineStatus}" :data-id="item.id" style="user-select: none" v-for="(item,index) in qkList" :key="index">
                      <i @click="singleSelect(index)" :class="{on: item.singleStatus,op: item.status == 0 || item.status == 3}"></i>
                      <div>
                        <div v-if="item.type-0 === 1" :style="{'background-image': `url(${item.cover || defaultImg})`}" class="bg">
                          <i v-if="item.type-0 === 2 || item.type-0 === 3" class="play"></i>
                        </div>
                        <div v-if="item.type-0 === 2 || item.type-0 === 3" :style="{'background-image': `url(${item.cover || defaultMedia})`}" class="bg">
                          <i class="play"></i>
                          <div v-if="item.status == 0 || item.status == 3" class="useMask">
                            <img v-if="item.status == 0" src="../assets/img/index/greenLoad.png" alt="">
                            <p v-if="item.status == 0" :style="'width:'+item.progress+'px'" class="line"></p>
                            <p v-if="item.status == 3" class="grey">转码失败</p>
                            <p @click="reRecode(item.id)" v-if="item.status == 3" class="green">重新转码</p>
                          </div>
                        </div>
                        <div @click="openDetail(index)" class="info">
                          <p>{{item.title}}</p>
                          <i :class="{video: item.type-0 === 2, pic: item.type-0 === 1, voice: item.type-0 === 3}"></i>
                        </div>
                      </div>
                      <img @click="delQk(item.id)" src="../assets/img/headline/bin.svg" alt="">
                    </li>
                    </draggable>
                  </ul>
                </div>
                <div class="bottom">
                  <div v-if="quickEdit || quickCompose" @click="allSelect=!allSelect;allSelected()" class="left-container">
                    <i :class="{on: allSelect}"></i>
                    <span>全选 ({{countNum}}/{{qkList.length}})</span>
                  </div>
                  <div class="right-container">
                    <p v-if="quickCompose" @click="allCompose" :class="{grey: isGrey}">一键合并</p>
                    <p v-if="quickEdit" @click="createVideo">创作视频</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-click-outside="closeMessage" class="message-container">
            <!-- <i title="消息任务" :class="{on: showMessage}" @click="getMsgList();showMessage = !showMessage"></i> -->
            <i title="消息任务" :class="{on: showMessage}" @click="showMessage = !showMessage"></i>
            <span :class="{on: !showRed}"></span>
            <div v-show="showMessage" class="new-message">
              <div class="new-message-title">任务消息</div>
              <MessageListComponent :visible="showMessage" :task-show-red="showRed" :taskFeedbackList="messageList" @open="openDetailCheck" @load="onMessageLoad" @clearAll="clearAllMessage" @show="showMessage = true"/>
            </div>
            <!-- <div v-show="showMessage" class="message">
              <p></p>
              <div>
                <div class="title">
                  <div class="left">任务消息</div>
                  <div @click="clearAllMessage" class="right">清空记录</div>
                </div>
                <div v-if="messageList.length == 0" class="empty">
                  <img src="../assets/img/common/newEmpty.png">
                  <p>暂无消息</p>
                </div>
                <div v-if="messageList.length > 0" class="msgContent" @scroll="getScroll1($event)">
                  <ul ref="msgDom">
                    <li @click="openDetail1(item)" v-for="(item, index) in messageList" :key="index">
                      <div>
                        <div class="type">{{item.type_name}}</div>
                        <div :class="{title: true,short: item.type == 5}">{{item.msg || item.name}}</div>
                      </div>
                      <div v-show="item.type == 5 && item.process != 100" style="font-size: 14px;color: #FFFFFF;">{{item.process + '%' || '0%'}}</div>
                      <div :class="{status: true, error: item.status=='3'}">{{item.status_name}}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
          </div>
          <div v-click-outside="closeSubscribe" v-if="sentimentShow" class="subscribe-container">
            <i title="订阅消息" :class="{on: showSubscribe}" @click="sbPage.pageIndex = 1;getSubscribeList();showSubscribe = !showSubscribe"></i>
            <span :class="{on: !showRed1}"></span>
            <div v-if="showSubscribe" class="subscribe-content">
              <div class="title">
                <div class="left">订阅消息</div>
                <div class="right">
                  <span>浏览器通知</span>
                  <div @click="setbrowsernotice" :class="{un: !sentimentNotice}">
                    <i></i>
                  </div>
                </div>
              </div>
              <div class="content" @scroll="getScroll2($event)">
                <ul ref="sbDom">
                  <li @click="toSubscribeDetail(item.hb_id, item.content_id, item.from, item.type)" v-for="item in sbList" :key="item.content_id">
                    <p class="t">{{item.title}}</p>
                    <p class="i">
                      <span class="time">{{item.raw_add_time}}</span>
                      <span>{{item.siteName}}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="info">
          <p class="name">
            {{user.name}}
          </p>
          <p class="sys">
            {{$_syscfg.title.toUpperCase()}}
          </p>
        </div>
        <img class="arrow" :src="user.expand ? user.icons.up : user.icons.down" alt="arrow">
        <div class="menu" v-show="user.expand">
          <div class="content">
            <div class="item">
              <div class="sysname">
                <span class="sys">{{characters.product_name}}</span>
              </div>
              <div class="dep">
                <div v-if="role_name&&depart_title">
                  <p v-if="role_name&&depart_title" class="role" @click="goLink()">
                    {{`${role_name} · ${depart_title}`}} <span v-if="is_more_role">......</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="handle">
            <p class="btn" @click="goUser()">
              <img src="../assets/img/headline/config.svg" alt="config">
              <span>个人设置</span>
            </p>
            <p class="btn quit" @click="quit()">
              <img src="../assets/img/headline/quit.svg" alt="quit">
              <span>退出</span>
            </p>
          </div>
        </div> -->
        </div>
        <div class="seprator"></div>
        <div class="help">
          <img v-show="has_app" src="../assets/img/headline/app.svg" alt="app" @mouseover="showQR(true)" @mouseout="showQR(false)">
          <span v-show="has_app" class="app" @mouseover="showQR(true)" @mouseout="showQR(false)">APP</span>
          <img src="../assets/img/headline/help.svg" title="帮助中心" @click="goHelp()">
        </div>
      </div>
    </div>
    <div class="appQr" v-show="system.showQR && !!system.appQr">
      <img :src="system.appQr" alt="qr">
    </div>

    <div v-if="create.tongyineirongku" ref="unifiedContentLibraryNewlyRef" class="unifiedContentLibraryNewly"></div>
  </div>
</template>
<script>
import common from "@common/common";
import globalFilter from "./globalFilter";
import filterGlobalFilter from "./filterGlobalFilter";
import { apis } from "@common/config";
import draggable from "vuedraggable";
import vClickOutside from "v-click-outside";
import { Notification } from "element-ui";
import MessageListComponent from "./messageList/index.vue";
import { loadMicroApp } from "qiankun";

export default {
  name: "headline",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    filterGlobalFilter,
    globalFilter,
    draggable,
    MessageListComponent
  },
  props: {
    params: {
      type: Object,
      required: true
    },
    isSearchResult: {
      type: Boolean,
      default: false
    },
    searchKeyWord: {
      type: String
    },
    saveSearch: {
      type: String || Object
    },
    statusName: {
      type: String
    },
    logoWidth: {
      type: Number,
      default: 230
    },
    isFold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getNewClient() {
      return this.$store.state.newClient;
    },
    getIcon() {
      return this.$store.state.icon;
    },
    /* 统一内容库 s */
    isLibraryDetail() {
      return this.$store.state.unifiedContentLibrary.isDetail;
    },
    libraryDetailInfo() {
      return this.$store.state.unifiedContentLibrary.detailInfo;
    },
    unifiedContentInstance() {
      return this.$store.state.unifiedContentLibrary.contentInstance;
    }
    /* 统一内容库 e */
  },
  watch: {
    params: {
      handler(e) {
        const path = this.$route.path.split("/")[1];
        if (e.title && path == "mediaPublishDetail") {
          this.pageTitle = e.title;
        }
        // 统一内容库
        if (path === "unifiedContentLibrary") {
          this.unifiedPageTitle = "统一内容库";
          if (this.$route.path === "/unifiedContentLibrary/content/interplay") {
            this.unifiedPageTitle = "Avid反推";
          }
        } else {
          this.unifiedPageTitle = "";
        }
        // 统一内容库
      },
      immediate: true,
      deep: true
    },
    getNewClient() {
      this.showRed1 = true;
    },
    getIcon(e) {
      this.icon = e;
    },
    $route: {
      handler: function(val) {
        // 路由变化时从配置中获取页面名称，防止非菜单页面无标题
        this.setStatusByData();
      }
    },
    "$store.state.messageList": function(e) {
      this.storeMessage = e;
    },
    "$store.state.showAvatar": function(e) {
      this.showAvatar = false;
    },
    "$store.state.showUpload": function(e) {
      this.showUpload = false;
    },
    "$store.state.showStorage": function(e) {
      this.showStorage = false;
    },
    "$store.state.showMessage": function(e) {
      this.showMessage = false;
    },
    "$store.state.quick_edit_num": function(e) {
      console.log(e);
      if (e > 99) {
        this.useNum = "...";
      } else {
        this.useNum = e;
      }
    },
    searchKeyWord(e) {
      this.searchKeyWord1 = e;
    }
  },
  data() {
    return {
      platformList: [],
      icon: {
        guihuanqueren: false,
        yanqishenpi: false
      },
      showMulti: false,
      loadSb: false,
      showSubscribe: false,
      showCenterFilter: false,
      quickCompose: false,
      has_app: false,
      showAvatar: false,
      showUpload: false,
      showStorage: false,
      showMessage: false,
      list2: [],
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/defaultMedia.png"),
      defaultAvatar: require("@assets/img/common/defaultAvatar.png"),
      pageTitle: "",
      showFilter: false,
      loadQk: true,
      loadMsg: true,
      allSelect: false,
      sentimentShow: false,
      sentimentNotice: false,
      searchKeyWord1: "",
      links: [
        {
          name: "快编系统",
          icon: require("@assets/img/headline/kuaibian.svg"),
          link: "/login",
          key: "kuaibianxitong"
        },
        {
          name: "新媒体发布",
          icon: require("@assets/img/headline/xinmeiti.svg"),
          link: "/index",
          key: "xinmeitifabu"
        },
        {
          name: "流程监控",
          icon: require("@assets/img/headline/liuchengjiankong.svg"),
          link: "/index",
          key: "liuchengjiankong"
        },
        {
          name: "管理系统",
          icon: require("@assets/img/headline/guanli.svg"),
          link: "/index",
          key: "guanlixitong"
        }
      ],
      user: {
        name: "",
        system: "",
        avatar: require("@assets/img/common/defaultAvatar.png"),
        icons: {
          up: require("../assets/img/headline/up.svg"),
          down: require("../assets/img/headline/down.svg")
        },
        expand: false
      },
      system: {
        appQr: "",
        qrSets: {
          "testxnews.smgtech.net": require("../assets/img/headline/appQr-test.png"),
          "zzb-xnews.smgtech.net": require("../assets/img/headline/appQr-test.png"),
          "xnews.smgtech.net": require("../assets/img/headline/appQr-product.png"),
          "devradio.smgtech.net": null
        },
        showQR: false
      },
      characters: {},
      menuData: [],
      is_more_role: false,
      role_name: null,
      depart_title: null,
      qkPage: {
        pageIndex: 1,
        pageSize: 50
      },
      msgPage: {
        pageIndex: 1,
        pageSize: 10
      },
      qkList: [],
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false,
        new_media: false,
        tongyineirongku: false
      },
      sbPage: {
        pageIndex: 1,
        pageSize: 10
      },
      quickEdit: true,
      has_stream_send: false,
      messageList: [],
      showRed: false,
      showRed1: false,
      storeMessage: [],
      saveMessageList: [],
      sbList: [],
      useNum: 0,
      isGrey: true,
      countNum: 0,
      unifiedPageTitle: "",
      showSystemNoticeRed: false,
      noticeList: [],

      // 统一内容库创建上传按钮列表
      unifiedContentLibraryNewlyAppList: []
    };
  },
  methods: {
    toThird(item, index) {
      console.log(item);
      if (index == 0) return;

      let info = {
        id: item.product_id,
        url: encodeURIComponent(item.url)
      };
      common.thirdNav(apis.redirectThird, { method: "get", data: info });
    },
    resourceType(to) {
      this.$store.commit("setResourceType", to);
    },
    toSubscribeDetail(hb_id, content_id, from, type) {
      if (from == "board") {
        common.jump(
          `/media?type=${type}&hb_id=${hb_id}&content_id=${content_id}`,
          true
        );
      } else {
        common.jump(`/client?id=${content_id}`, true);
      }
    },
    getSubscribeList() {
      this.showRed1 = false;
      let info = {
        page: this.sbPage.pageIndex,
        pagesize: this.sbPage.pageSize
      };

      common.myFetch(apis.browsermsg, info).then(res => {
        // console.log(res)
        this.loadSb = true;
        if (this.sbPage.pageIndex == 1) {
          this.sbList = res.list;
        } else {
          this.sbList = this.sbList.concat(res.list);
        }
      });
    },
    setbrowsernotice() {
      this.sentimentNotice = !this.sentimentNotice;

      let info = {
        need_push: this.sentimentNotice ? 1 : 0
      };

      common.myFetch(apis.browsernotice, info).then(res => {
        console.log(res);
        this.$toast(res);
        this.$store.commit("setSentimentNotice", this.sentimentNotice);
      });
    },
    closeSubscribe() {
      this.showSubscribe = false;
    },
    filterBox() {
      this.$filterBox(this.saveSearch).then(e => {
        if (e) {
          this.$emit("newSearch", e);
        }
      });
    },
    keywordChange(e) {
      this.$emit("keywordChange", e);
    },
    clearAllMessage() {
      let data = {};
      common.myFetch(apis.clearmsg, data).then(res => {
        if (res) {
          this.messageList = [];
          this.$toast(res);
        }
      });
    },
    imgError() {
      this.user.avatar = this.defaultAvatar;
    },
    closeAvatar() {
      this.showAvatar = false;
    },
    closeUpload() {
      this.showUpload = false;
    },
    closeStorage() {
      this.showStorage = false;
      this.qkList = [];
      this.qkPage.pageIndex = 1;
      this.isGrey = true;
      this.allSelect = false;
    },
    closeMessage() {
      this.showMessage = false;
      this.messageList = [];
      this.saveMessageList = [];
      this.msgPage.pageIndex = 1;
    },
    log: function(evt) {
      console.log(evt, this.qkList);
      let arr = [];
      this.qkList.forEach(el => {
        // el.lineStatus = false;
        arr.push(el.id);
      });
      arr = arr.join(",");
      let data = {
        file_ids: arr
      };
      common.myFetch(apis.File_updatequickfilesort, data).then(res => {
        if (res) {
          console.log(res);
          this.$toast(res);
        }
      });
      if (evt.added) {
        this.count += 1;
        const item = evt.added.element;
        const idx = this.list2.findIndex(e => e.id === item.id);
        let temp = JSON.parse(JSON.stringify(this.list2));
        temp[idx].id = this.count;
        this.list2 = temp;
        console.log(this.list2, this.qkList);
      }
    },
    reRecode(id) {
      const info = {
        file_id: id
      };
      common.myFetch(apis.file_recode, info).then(data => {
        if (data) {
          console.log(data);
          this.$toast(data);
          this.qkPage.pageIndex = 1;
          this.getQkList();
        }
      });
    },
    allCompose() {
      let file_ids = [];
      this.qkList.forEach(el => {
        if (el.singleStatus) {
          file_ids.push(el.id);
        }
      });
      file_ids = file_ids.join(",");
      const info = {
        file_ids: file_ids
      };
      common.myFetch(apis.oneCompose, info).then(data => {
        if (data) {
          this.$toast(data);
          this.qkPage.pageIndex = 1;
          this.getQkList();
          this.countNum = 0;
        }
      });
    },
    allSelected() {
      let count = 0;
      if (this.allSelect) {
        this.qkList.forEach(el => {
          if (el.status == 2) {
            el.singleStatus = true;
          }
        });
        this.qkList.forEach(el => {
          if (el.singleStatus) {
            count++;
          }
        });
        if (count > 1) {
          this.isGrey = false;
        } else {
          this.isGrey = true;
        }
      } else {
        this.qkList.forEach(el => {
          el.singleStatus = false;
        });
        this.qkList.forEach(el => {
          if (el.singleStatus) {
            count++;
          }
        });
        if (count > 1) {
          this.isGrey = false;
        } else {
          this.isGrey = true;
        }
      }

      this.countNum = count;
    },
    singleSelect(index) {
      let count = 0;
      if (!this.qkList[index].singleStatus) {
        if (this.qkList[index].status == 2) {
          this.qkList[index].singleStatus = true;
        }
        this.qkList.forEach(el => {
          if (el.singleStatus) {
            count++;
          }
        });
        if (count > 1) {
          this.isGrey = false;
        } else {
          this.isGrey = true;
        }
      } else {
        this.qkList[index].singleStatus = false;
        this.allSelect = false;
        this.qkList.forEach(el => {
          if (el.singleStatus) {
            count++;
          }
        });
        if (count > 1) {
          this.isGrey = false;
        } else {
          this.isGrey = true;
        }
      }
      this.countNum = count;
    },
    createVideo() {
      let name = [];
      let id = [];

      this.qkList.forEach(el => {
        // console.log(el)
        if (el.singleStatus) {
          name.push(el.title);
          id.push(el.id);
        }
      });

      name = name.join(",");
      id = id.join(",");

      let info = {
        title: "",
        id: ""
      };

      if (id && name) {
        info.title = name;
        info.id = id;
      }

      // console.log(info)

      // return false

      this.$cloudEditConfirm(info).then(res => {
        if (res != 999) {
          this.qkList = [];
          this.qkPage.pageIndex = 1;
          this.getQkList();
          let unid = common.getUnid();
          let uid = common.getUid();
          this.countNum = 0;
          // window.location.href = "http://editortest.smgtech.net/App?token="+uid+"--"+unid+"&projectId=" + res.id
          window.open(res.meisheurl);
          // window.location.href =
        }
      });

      // console.log(name,id)
    },
    delQk(id) {
      const info = {
        file_ids: id
      };

      common.myFetch(apis.delQuickEdit, info).then(data => {
        if (data) {
          this.$toast("删除成功");
          this.qkList = this.qkList.filter(el => {
            return el.id != id;
          });
          if (this.qkList.length > 99) {
            this.useNum = "...";
          } else {
            this.useNum = this.qkList.length;
          }
        }
      });
    },
    test() {},
    getMsgList() {
      //  0任务反馈1文件传输2系统消息
      const info = {
        page: this.msgPage.pageIndex,
        pagesize: this.msgPage.pageSize,
        msg_type: 0
      };
      common.myFetch(apis.msglist, info).then(data => {
        if (data) {
          if (this.msgPage.pageIndex == 1) {
            this.messageList = [];
            this.saveMessageList = [];
          }
          this.showRed = false;
          let messageList = [];
          // console.log(this.storeMessage);
          this.saveMessageList = this.saveMessageList.concat(data.list);
          messageList = this.storeMessage;
          messageList = messageList.concat(this.saveMessageList);
          console.log(messageList);
          messageList.forEach(val => {
            // console.log(val)
            if (val.type == 5) {
              console.log(val.process);
              if (val.process == 100) {
                this.$set(val, "status_name", "完成");
              }
              if (val.status == 3) {
                this.$set(val, "status", "3");
                this.$set(val, "status_name", "失败");
              }
              this.$set(val, "process", val.process);
              // val.process = val.process+'%'
            }
          });

          this.messageList = messageList;
          // if(this.msgPage.pageIndex == 1){
          //   this.messageList = this.messageList.concat(this.storeMessage);
          // }
          // this.messageList = this.messageList.concat(data.list);
          this.$nextTick(() => {
            this.loadMsg = true;
          });
          // console.log(data);
        }
      });
    },
    getSystemNoticeMsg() {
      // 0系统消息1文件传输2任务反馈
      const info = {
        page: this.msgPage.pageIndex,
        pagesize: this.msgPage.pageSize,
        msg_type: 2
      };
      common
        .myFetch(apis.msglist, info)
        .then(data => {
          if (data) {
            if (this.msgPage.pageIndex == 1) {
              this.noticeList = [];
            }
            this.showSystemNoticeRed = false;
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loadMsg = true;
          });
        });
    },
    openDetail(index) {
      let data = {
        type: this.qkList[index].type,
        id: this.qkList[index].id,
        create: this.create,
        canEdit: false,
        quickEdit: this.quickEdit
      };
      this.$materialBox(data, this.test);
    },
    // 打开消息列表的详情前的文件id判断是否是新老素材
    openDetailCheck(item) {
      if (item.subject_type == 15) {
        // 统一内容素材详情
        common.jumpOut(
          `/unifiedContentLibrary/content/detail/${item.subject_id}`
        );
      }else if (item.subject_type == 16 || item.subject_type == 18) {
        // 统一内容 内容详情地址
        common.jumpOut(
          `/unifiedContentLibrary/content/doc/detail/${item.subject_id}`
        );
      } else {
        common
          .myFetch(apis.checkNoticefile, { file_id: item.subject_id })
          .then(res => {
            if (res) {
              if (res.is_content_hub) {
                // 新
                // 统一内容素材详情
                common.jumpOut(
                  `/unifiedContentLibrary/content/detail/${item.subject_id}`
                );
              } else {
                this.openDetail1(item);
              }
            } else {
              this.openDetail1(item);
            }
          })
          .catch(err => {
            this.openDetail1(item);
          });
      }
    },
    /**
     * 打开消息列表的详情
     */
    openDetail1(item) {
      console.log("openDetail1 item", item);
      // subject_type 关联类型0素材
      if (item.subject_type == 1 && item.status != 2) return;

      if (item.subject_type == 2) {
        let info = {
          id: item.id
        };
        // 如果是 完成 或者失败
        // if (item.status == 2 || item.status == 3) {
        //   common.myFetch(apis.readmsg, info).then(data => {
        //     if (data) {
        //       console.log(data);
        //       // this.messageList = this.messageList.filter(el => {
        //       //   return el.id != item.id
        //       // })
        //     }
        //   });
        // }
        common.jump(`/reportDetail?d=${item.subject_id}`, true);
      } else if(item.subject_type == 17){
        common.jump(`/onlinePlayingLibrary/playList/${item.playlist_id}/${item.subject_idstring}`, true);
      } else if (item.subject_type == 0 || item.subject_type == 6) {
        // if(item.status == 2){
        let data = {
          type: item.subject_type,
          id: item.subject_id,
          create: this.create,
          canEdit: false,
          quickEdit: this.quickEdit
        };
        // 如果是已完成处理的技审。点开要直接到 技审tab
        // 0:上传中 1:处理中 2:完成 3:失败
        if (item.type == 4 && (item.status == 2 || item.status == 3)) {
          data.tabIndex = 4;
        }
        if (item.type == 12) {
          data.toTag = true;
        }
        let info = {
          id: item.id
        };
        // 如果是 完成 或者失败
        // if (item.status == 2 || item.status == 3) {
        //   common.myFetch(apis.readmsg, info).then(data => {
        //     if (data) {
        //       console.log(data);
        //     }
        //   });
        // }
        this.$materialBox(data, this.test);
        // }
      } else if (item.subject_type == 3) {
        let info = {
          id: item.id
        };
        // 如果是 完成 或者失败
        // if (item.status == 2 || item.status == 3) {
        //   common.myFetch(apis.readmsg, info).then(data => {
        //     if (data) {
        //       console.log(data);
        //       // this.messageList = this.messageList.filter(el => {
        //       //   return el.id != item.id
        //       // })
        //     }
        //   });
        // }
        common.jump(`/publishDetail?d=${item.subject_id}`, true);
      } else if (item.subject_type == 4) {
        if (item.status == 2) {
          let data = {
            type: item.subject_type,
            id: item.subject_id,
            create: this.create,
            canEdit: false,
            quickEdit: this.quickEdit
          };
          // 如果是已完成处理的技审。点开要直接到 技审tab
          // 0:上传中 1:处理中 2:完成 3:失败
          if (item.type == 4 && (item.status == 2 || item.status == 3)) {
            data.tabIndex = 4;
          }
          let info = {
            id: item.id
          };
          // 如果是 完成 或者失败
          // if (item.status == 2 || item.status == 3) {
          //   common.myFetch(apis.readmsg, info).then(data => {
          //     if (data) {
          //       console.log(data);
          //     }
          //   });
          // }
          this.$materialBox(data, this.test);
        }
      } else if (item.subject_type == 5) {
        if (item.status == 2) {
          let data = {
            type: item.subject_type,
            id: item.subject_id,
            create: this.create,
            canEdit: false,
            quickEdit: this.quickEdit
          };
          // 如果是已完成处理的技审。点开要直接到 技审tab
          // 0:上传中 1:处理中 2:完成 3:失败
          if (item.type == 4 && (item.status == 2 || item.status == 3)) {
            data.tabIndex = 4;
          }
          let info = {
            id: item.id
          };
          // 如果是 完成 或者失败
          // if (item.status == 2 || item.status == 3) {
          //   common.myFetch(apis.readmsg, info).then(data => {
          //     if (data) {
          //       console.log(data);
          //     }
          //   });
          // }
          this.$materialBox(data, this.test);
        }
      } else if (item.subject_type == 7) {
        common.jump(`/clueDetail?d=${item.subject_id}`, true);
      } else if (item.subject_type == 8) {
        common.jump(`/mediaPublishDetail?d=${item.subject_id}`, true);
      } else if (item.subject_type == 10) {
        if (item.status == 2) {
          common.jump(`/contentTrackDetail?d=${item.subject_id}`, true);
        }
      } else if (item.subject_type == 11) {
        if (item.status == 2) {
          common.jump(`/themeTrack?d=${item.subject_id}`, true);
        }
      } else if (item.subject_type == 12) {
        if (item.status == 2) {
          let data = {
            type: item.subject_type,
            id: item.subject_id,
            create: this.create,
            canEdit: false,
            quickEdit: this.quickEdit
          };

          if (item.type == 4 && (item.status == 2 || item.status == 3)) {
            data.tabIndex = 4;
          }

          this.$materialBox(data, this.test);
        }
      } else if (item.subject_type == 14) {
        common.jumpOut(item.bound_url);
      } else {
        let data = {
          type: item.subject_type,
          id: item.subject_id,
          create: this.create,
          canEdit: false,
          quickEdit: this.quickEdit
        };
        // 如果是已完成处理的技审。点开要直接到 技审tab
        // 0:上传中 1:处理中 2:完成 3:失败
        if (item.type == 4 && (item.status == 2 || item.status == 3)) {
          data.tabIndex = 4;
        }
        let info = {
          id: item.id
        };
        // 如果是 完成 或者失败
        // if (item.status == 2 || item.status == 3) {
        //   common.myFetch(apis.readmsg, info).then(data => {
        //     if (data) {
        //       console.log(data);
        //     }
        //   });
        // }
        this.$materialBox(data, this.test);
      }
    },
    async navigate(type) {
      this.closeUpload();
      if (type === "interview") {
        common.jump("/newInterview", true);
      } else if (type === "material") {
        common.jump("/creatClue?t=0", true);
      } else if (type === "report") {
        const typeName = await this.$pageType();
        if (!typeName) return;
        common.jump(`/creatReport?t=${typeName}`, true);
      } else if (type === "publish") {
        const typeName = await this.$pageType("publish");
        if (!typeName) return;
        common.jump(`/createPublish?t=${typeName}`, true);
      } else if (type === "new_media") {
        const typeName = await this.$MediaPlatform();
        if (!typeName) return;
        common.jump(`/createMediaPublish?d=${typeName}`, true);
      }
    },
    getQrcode() {
      common.myFetch(apis.User_qrcode, {}, "post").then(data => {
        if (data) {
          // console.log(data)
          this.system.appQr = data.qr_url;
        }
      });
    },
    jumpLink(l) {
      console.log(l);
      // 管理系统调整逻辑
       if(l.key === 'guanlixitong') {
         this.checkGuanlixitong(l.link);
       }else {
         // 跳转管理后台页面
         const url = l.link;

         window.open(url, "_blank");
       }

      // 跳转管理后台页面
        // const url = l.link;

        // window.open(url, "_blank");
      
    },
    async checkGuanlixitong(url){
      window.open(window.location.origin + '/h5/#/home', "_blank");
      // try {
      //   const r = await common.getUserInfo();
      //   if(r.is_admin == 1) {
      //     window.open(window.location.origin + '/h5/#/home', "_blank");
      //   }else {
      //     window.open(url, "_blank");
      //   }
      // } catch (error) {
      //     window.open(url, "_blank");
      // }
    },
    quit() {
      common.myFetch(apis.Log_logout, {}, "post").then(data => {
        if (data) {
          common.clearUser();
          this.$router.push({
            path: "/login"
          });

        }
      });
    },
    goSet() {
      this.$router.push({
        path: "/user"
      });
      this.closeAvatar();
    },
    goMaterial() {
      const path = this.$route.path.split("/")[1];
      if (path == "myMaterial") {
        window.location.reload();
      } else {
        this.$router.push({
          path: "/myMaterial/materialList"
        });
      }
      this.closeAvatar();
      // common.jump("/myMaterial/materialList", true);
    },
    goHelp() {
      common.jump("/help", true);
    },
    showQR(status) {
      console.log(status);
      this.$set(this.system, "showQR", status);
    },
    goIndex() {
      this.$router.push({
        path: "/index"
      });
    },
    toggleMenu(status) {
      this.user.expand = status;
    },
    clearUser() {
      common.clearUser();
    },
    goUser() {
      this.user.expand = false;
      this.$router.push({
        path: "/user"
      });
    },
    passFilterData(d) {
      if (d && d.types && d.types.length > 0) {
        this.showFilter = true;
      }

      this.$nextTick(() => {
        this.$refs.globalFilter.getData(d);
      });
    },
    handleCharacters(data) {
      data["XNews"] = [
        {
          id: data["XNews"][0].id,
          name: data["XNews"][0].name,
          role: [
            {
              id: data["XNews"][0].role[0].id,
              role_id: data["XNews"][0].role[0].role_id,
              title: data["XNews"][0].role[0].title
            }
          ]
        }
      ];
    },
    getHasNew() {
      common.myFetch(apis.senHasNew, {}, "post").then(data => {
        if (data) {
          // console.log(data)
          this.showRed1 = data.has_new;
        }
      });
    },
    async getUserMenu() {
      // 获取用户信息数据
      const r = await common.getUserInfo();
      if (r.hasgpt) {
        this.$chatGpt(r.gpt_url);
      }
      this.user.avatar = r.avatar || this.defaultAvatar;
      this.user.name = r.truename;
      this.quickCompose = r.quickCompose;
      // this.handleCharacters(r.roles)

      if (r.roles && r.roles.departs.length > 0) {
        this.depart_title = r.roles.departs[0].depart_title;
        if (r.roles.departs[0].roles && r.roles.departs[0].roles.length > 0) {
          this.role_name = r.roles.departs[0].roles[0].role_name;
        }
        if (r.roles.departs.length > 1) {
          this.is_more_role = true;
        } else {
          r.roles.departs.forEach(i => {
            if (i.roles && i.roles.length > 1) {
              this.is_more_role = true;
            }
          });
        }
      }

      this.create.interview = r.create.interview;
      this.create.material = r.create.material;
      this.create.publish = r.create.publish;
      this.create.report = r.create.report;
      this.create.new_media = r.create.new_media;
      this.quickEdit = r.quickEdit;
      this.sentimentShow = r.has_sentiment;
      this.sentimentNotice = r.sentiment_notice;
      this.has_stream_send = r.has_stream_send;
      this.showRed = r.hasNewMsg;
      this.has_app = r.has_app;

      let has_datacenter = r.has_datacenter;
      let has_sentiment = r.has_sentiment;

      if (r.has_sentiment) {
        this.getHasNew();
      }

      if (r.editvideo_nums > 99) {
        this.useNum = "...";
      } else {
        this.useNum = r.editvideo_nums;
      }

      this.$store.commit("setStreamSend", this.has_stream_send);
      this.$store.commit("setquickEdit", this.quickEdit);
      this.$store.commit("setCreate", this.create);
      this.$store.commit("setUserSpace", r.user_space);
      this.$store.commit("setSentimentNotice", this.sentimentNotice);
      this.$store.commit("setHasDatacenter", has_datacenter);
      this.$store.commit("setHasSentiment", has_sentiment);

      this.characters = r.roles;
      this.links.forEach(i => {
        if (i.key === "guanlixitong") {
          this.$set(i, "link", r.hometopauth.guanlixitong.url);
          this.$set(i, "show", r.hometopauth.guanlixitong.is_show);
        } else if (i.key === "kuaibianxitong") {
          this.$set(i, "link", r.hometopauth.kuaibianxitong.url);
          this.$set(i, "show", r.hometopauth.kuaibianxitong.is_show);
        } else if (i.key === "xinmeitifabu") {
          this.$set(i, "link", r.hometopauth.xinmeitifabu.url);
          this.$set(i, "show", r.hometopauth.xinmeitifabu.is_show);
        } else if (i.key === "liuchengjiankong") {
          this.$set(i, "link", r.hometopauth.liuchengjiankon.url);
          this.$set(i, "show", r.hometopauth.liuchengjiankon.is_show);
        }
      });
    },
    goLink(c, k) {
      // 菜单跳转链接
      // if (k === 'XNews') {
      this.$router.push({
        name: "user",
        params: {
          tab: "部门角色"
        }
      });

      this.user.expand = false;
      // }
    },
    getRoutes(r) {
      // 从slide组件获取数据
      this.menuData = r;
      this.setStatusByData();
      this.setNewlyBtn(r);
    },
    checkIsMaterial() {
      const path = this.$route.path.split("/")[1];
      const idstring = this.$route.params.id;
      const r = this.$route.query.r;
      if ("myMaterial" === path && "materialList" === idstring) {
        // console.log(999);
        this.pageTitle = "我的素材";
        this.showFilter = true;
      } else if (
        "mediaPublishLibrary" === path &&
        "xinmeitifabuku" === idstring
      ) {
        this.showFilter = true;
      } else if ("myMediaPublish" === path && "xinmeitiwodefabu" === idstring) {
        this.showFilter = true;
      } else if ("voiceRec" === path) {
        this.pageTitle = "语音识别";
        this.showFilter = true;
      } else if ("voiceEditList" === path) {
        this.pageTitle = "音频剪辑";
        this.showFilter = true;
      } else if ("voiceComposeList" === path) {
        this.pageTitle = "语音合成";
        this.showFilter = true;
      } else if ("newTopicDetail" === path) {
        this.pageTitle = "选题详情";
        this.showFilter = false;
      } else if ("newTopicList" === path) {
        this.pageTitle = "选题库";
      } else if ("newMyTopic" === path) {
        this.pageTitle = "我的选题";
        this.showFilter = true;
      } else if ("newTopicAudit" === path) {
        this.pageTitle = "选题审核";
        this.showFilter = true;
      } else if ("newTopicEdit" === path && !r) {
        this.pageTitle = "新建选题";
        this.showFilter = false;
      } else if ("newTopicEdit" === path && r) {
        this.pageTitle = "编辑选题";
        this.showFilter = false;
      } else if ("onlinePlayingLibrary" === path) {
        this.pageTitle = "演播室播单";
        if(this.$route.params.pathMatch == 'onlineList'){
          this.showFilter = true;
          let filterData = {
            types: [{
              name: '播单名称',
              code: 'title',
              selected: true
            },{
              name: '创建人',
              code: 'username',
              selected: false
            }],
            callback: null
          }

          this.$nextTick(()=>{
            if(this.$refs.globalFilter){
              console.log(filterData, this.$refs.globalFilter)
              this.$refs.globalFilter.getData(filterData)
            }
          })
          
        }else if(this.$route.params.pathMatch == 'allDayList'){
          this.pageTitle = "24H播单";
          this.showFilter = true;
          let filterData = {
            types: [{
              name: '播单名称',
              code: 'title',
              selected: true
            },{
              name: '创建人',
              code: 'username',
              selected: false
            }],
            callback: null
          }

          this.$nextTick(()=>{
            if(this.$refs.globalFilter){
              console.log(filterData, this.$refs.globalFilter)
              this.$refs.globalFilter.getData(filterData)
            }
          })
        }else{
          this.showFilter = false;
        }
      } else if ("sportsUp" === path) {
        this.pageTitle = "体育资讯上屏";
        this.showFilter = true;
      }

      if ("filter" === path) {
        // console.log(999);
        this.showCenterFilter = true;
      }
      // else if("publicLibrary" === path){
      //   this.showFilter = true;
      // }
    },
    setStatusByData() {
      // 根据数据或配置设置菜单数据状态
      const path = this.$route.path.split("/")[1];
      const idstring = this.$route.params.id;
      let title = "";
      let search = false;

      if (this.$route.params.id == "tuozhanshebei") {
        this.showMulti = true;
      } else {
        this.showMulti = false;
      }

      // console.log(this.menuData);

      this.menuData.forEach(i => {
        i.son.forEach(m => {
          if (m.menu_type === path && m.idstring === idstring) {
            title = m.title;
            search = m.has_search - 0 === 1;
          }
        });
      });

      const specialPages = [
        "newTopic",
        "newInterview",
        "publicLibrary",
        "publicDetail",
        "voiceRec",
        "voiceEditList",
        "voiceComposeList"
      ]; // 特殊页面，需要手动修改title
      if (specialPages.indexOf(path) > -1) {
        if (path === "newTopic") {
          title = `新建${this.$_syscfg.topic}`;
        } else if (path === "newInterview") {
          title = `新建${this.$_syscfg.interview}`;
        } else if (path === "publicLibrary") {
          title = `公共串联单库`;
        } else if (path === "publicDetail") {
          title = `公共串联单详情`;
        } else if (path === "voiceRec") {
          title = `语音识别`;
        } else if (path === "voiceEditList") {
          title = `音频剪辑`;
        } else if (path === "voiceComposeList") {
          title = `语音合成`;
        } else if (path === "sportsUp" ) {
          title = `体育资讯上屏`;
        }
      }

      this.pageTitle = title || this.params.title;
      this.showFilter = search;

      this.checkIsMaterial();
    },
    getQkList() {
      let data = {
        page: this.qkPage.pageIndex,
        pagesize: this.qkPage.pageSize
      };

      common.myFetch(apis.File_quickfiles, data).then(res => {
        if (res) {
          res.list.forEach(el => {
            el.singleStatus = false;
          });
          this.loadQk = false;
          // let qkList = this.qkList.concat(res.list);
          // this.qkList = this.qkList.concat(res.list);
          let qkList = [];
          res.list.forEach(el => {
            el.lineStatus = false;
          });
          qkList = res.list;
          this.qkList = this.uniqObjInArray(qkList);
          this.$nextTick(() => {
            this.loadQk = true;
            this.dragMethod();
          });
        }
      });
    },
    getScroll(e) {
      if (e) {
        let height = 280;
        let scrollTop = e.target.scrollTop;
        let offsetHeight = this.$refs.qkDom.offsetHeight;
        if (scrollTop / (offsetHeight - height + 0.22) >= 0.95) {
          //到达底部100px时,加载新内容
          if (this.loadQk) {
            this.loadQk = false;
            this.qkPage.pageIndex++;
            // this.getQkList();
          }
        }
      }
    },
    getScroll1(e) {
      if (e) {
        let height = 300;
        let scrollTop = e.target.scrollTop;
        let offsetHeight = this.$refs.msgDom.offsetHeight;
        if (scrollTop / (offsetHeight - height + 0.2) >= 0.95) {
          //到达底部100px时,加载新内容
          if (this.loadMsg) {
            this.loadMsg = false;
            this.msgPage.pageIndex++;
            this.getMsgList();
          }
        }
      }
    },
    onMessageLoad(status, type) {
      if (this.loadMsg) {
        this.loadMsg = false;
        if (type === "init") {
          this.msgPage.pageIndex = 1;
        } else {
          this.msgPage.pageIndex++;
        }
        if (status === 2) {
          this.getMsgList();
        } else {
          this.getSystemNoticeMsg();
        }
      }
    },
    getScroll2(e) {
      if (e) {
        let height = 500;
        let scrollTop = e.target.scrollTop;
        let offsetHeight = this.$refs.sbDom.offsetHeight;
        // console.log(scrollTop / (offsetHeight - height + 0.2))
        if (scrollTop / (offsetHeight - height + 0.2) >= 0.95) {
          console.log(123);
          //到达底部100px时,加载新内容
          if (this.loadSb) {
            this.loadSb = false;
            this.sbPage.pageIndex++;
            this.getSubscribeList();
          }
        }
      }
    },
    uniqObjInArray(objarray) {
      let res = objarray;
      let obj = {};

      res = res.reduce((cur, next) => {
        if (!obj[next.id]) {
          obj[next.id] = true;
          cur.push(next);
        }
        return cur;
      }, []);

      return res;
    },
    setNew() {
      this.showRed = true;
    },
    setNew1() {
      this.showRed1 = true;
    },
    setNum(e) {
      if (e.content.content.editvideo_nums > 99) {
        this.useNum = "...";
      } else {
        this.useNum = e.content.content.editvideo_nums;
      }
    },
    dragMethod() {
      let that = this;
      var ul = this.$refs.qkDom;
      // 把ul设置为有效的放置目标
      ul.ondragover = function(event) {
        event.preventDefault();
      };
      var draging; // 存放被拖动元素
      ul.ondragstart = function(event) {
        draging = event.target;
        // console.log(draging)
        // let indexName = getIndex(draging);
        // that.qkList[indexName].lineStatus = true;
      };
      ul.ondrop = function(event) {
        var target = event.target; // 放置目标
        if (target.nodeName != "LI") {
          target = target.parentNode.parentNode;
        }
        if (target.nodeName === "LI" && target !== draging) {
          console.log(getIndex(draging), getIndex(target));
          if (getIndex(draging) < getIndex(target)) {
            target.parentNode.insertBefore(draging, target.nextSibling);
          } else {
            target.parentNode.insertBefore(draging, target);
          }
          let save = that.qkList[getIndex(draging)];
          that.qkList[getIndex(draging)] = that.qkList[getIndex(target)];
          that.qkList[getIndex(target)] = save;
          let arr = [];
          that.qkList.forEach(el => {
            // el.lineStatus = false;
            arr.push(el.id);
          });
          arr = arr.join(",");
          let data = {
            file_ids: arr
          };
          common.myFetch(apis.File_updatequickfilesort, data).then(res => {
            if (res) {
              console.log(res);
              that.$toast(res);
            }
          });
          // console.log(arr.join(','))
        }
      };
      // 获取当前元素index
      function getIndex(el) {
        var index = 0;
        if (!el || !el.parentNode) {
          return -1;
        }
        while ((el = el.previousElementSibling)) {
          index++;
        }
        return index;
      }
    },
    setTransProgress(e) {
      // console.log(e)
      if (this.qkList.length > 0) {
        this.qkList.forEach(el => {
          if (el.id == e.content.id) {
            el.progress = e.content.progress;
            el.status = e.content.status;
          }
        });
      }
      // qkList
    },
    setResult(e) {
      let title = "";
      let message = "";
      if (e.content.category === "compose") {
        if (e.content.status == 0) {
          title = "素材合成失败";
          message = `素材${e.content.title}合成失败，请在我的素材中查看。`;
        } else {
          title = "素材合成成功";
          message = `素材${e.content.title}合成成功，请在我的素材中查看。`;
        }
      } else if (e.content.category === "cloud_clip") {
        if (e.content.status == 0) {
          title = "素材创作失败";
          message = `素材${e.content.title}创作失败，请在我的素材中查看。`;
        } else {
          title = "素材创作成功";
          message = `素材${e.content.title}创作成功，请在我的素材中查看。`;
        }
      } else if (
        e.content.category === "pushhd" ||
        e.content.category === "anchor" ||
        e.content.category === "stream_media" ||
        e.content.category === "tag_transcode"
      ) {
        title = e.content.title;
        message = e.content.detail;
      } else if (e.content.category === "track") {
        title = e.content.title;
        message = e.content.detail;
        this.$emit("reload");
      }

      setTimeout(() => {
        Notification({
          customClass: "wp",
          type: e.content.status ? "success" : "error",
          title: title,
          message: message,
          offset: 40,
          duration: 3000
        });
      }, 1000);
    },
    setComposeProgress(e) {
      console.log(e);
      this.messageList.forEach(el => {
        if (el.id == e.content.id) {
          if (e.content.progress == 100) {
            this.$set(el, "status_name", "完成");
          }
          if (e.content.status == 3) {
            this.$set(el, "status", "3");
            this.$set(el, "status_name", "失败");
          }
          this.$set(el, "process", e.content.progress);
        }
      });

      console.log(this.messageList);
    },
    searchStream() {
      this.$emit("search", this.searchKeyWord1);
      console.log(this.searchKeyWord1);
    },
    getRedirectSystems() {
      common.myFetch(apis.getRedirectSystems).then(res => {
        if (res) {
          this.platformList = res.list;
          // console.log(res)
        }
      });
    },
    /* 统一内容库详情方法 s */
    handleUnifiedBack() {
      this.unifiedContentInstance.contentDetailBtnOperate.back();
    },
    handleUnifiedDownload() {
      this.unifiedContentInstance.contentDetailBtnOperate.download();
    },
    handleUnifiedJovone() {
      this.unifiedContentInstance.contentDetailBtnOperate.jone();
    },
    handleUnifiedOp(event) {
      this.unifiedContentInstance.contentDetailBtnOperate.op(event);
    },
    setNewlyBtn(r) {
      console.log('setNewlyBtn', r);
      if(!r || r.length === 0) return;
      const tongyiItem = r.find(v => v.idstring === "tongyineirongku");
      if(!tongyiItem) return;
      if(!tongyiItem.son || tongyiItem.son.length === 0) return;
      const materialItem = tongyiItem.son.find(v => v.idstring === "ty_material");
      const reportItem = tongyiItem.son.find(v => v.idstring === "ty_report");
      this.create.tongyineirongku = !!materialItem || !!reportItem
      if(!this.create.tongyineirongku) return
      this.$nextTick(() => {
        const timeStr = Date.now();
        const entryPath =
          process.env.NODE_ENV === "production"
            ? `${window.origin}/libraryCreator/`
            : "//localhost:5175";
        const parentInstance = {
          uploadClick: () => {
            this.$store.dispatch("unifiedContentLibrary/uploadBtnClick");
          },
          getUserKeys: () => {
            return common.userKeys();
          },
          getCommon: () => {
            return common;
          },
          registerContentInstance: instance => {
            this.$store.dispatch("unifiedContentLibrary/setContentInstance", {
              ...this.contentInstance,
              ...instance
            });
          },
          updateUploadList: list => {
            this.$store.dispatch("unifiedContentLibrary/setUploadList", list);
          },
          updateUploadStatus: data => {
            this.$store.dispatch("unifiedContentLibrary/setUploadStatus", data);
          },
          toggleUploadModal: val => {
            this.$store.dispatch(
              "unifiedContentLibrary/setIsShowUploadModal",
              val
            );
          },
          setDetailInfo: (data, bool) => {
            this.$store.dispatch("unifiedContentLibrary/setIsDetail", bool);
            this.$store.dispatch("unifiedContentLibrary/setDetailInfo", data);
          },
          getSystemConfig: () => {
            return this.$_syscfg;
          },
          getThis: () => {
            return this;
          },
          updateNewlyAppList: list=>{
            this.unifiedContentLibraryNewlyAppList = list
          }
        };
        this.microApp = loadMicroApp(
          {
            name: "unified-content-library_creator",
            entry: entryPath + "?time=" + timeStr,
            container: this.$refs.unifiedContentLibraryNewlyRef,
            props: { parentInstance: parentInstance, }
          },
          {
            sandbox: {
              experimentalStyleIsolation: true // 样式隔离
            }
          }
        );
      });
    }
    /* 统一内容库详情方法 e */
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img;

    this.defaultMedia = this.$_syscfg.default_media;

    this.defaultAvatar = this.$_syscfg.default_avatar;

    this.user.avatar = this.$_syscfg.default_avatar;

    this.searchKeyWord1 = this.searchKeyWord;

    this.checkIsMaterial();

    this.getUserMenu();

    this.getRedirectSystems();

    // this.system.appQr = this.system.qrSets[window.document.domain]
    this.getQrcode();

    setTimeout(() => {
      this.setStatusByData(); // 页面新建或刷新时需设置数据
    }, 0);

    common.handleSocket(this.setNew, "newmsg");

    common.handleSocket(this.setNum, "editvideonum");

    common.handleSocket(this.setTransProgress, "meishetranscode");

    common.handleSocket(this.setResult, "result");

    common.handleSocket(this.setComposeProgress, "compose");

    this.$FileSend();
  },
  beforeDestroy() {
    // 组件销毁时手动卸载微应用
    if (this.microApp) {
      this.microApp.unmount();
      this.microApp = null;
      console.log('微应用已卸载');
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/global.less";
@keyframes folding {
  0% {
    width: 230px;
  }
  100% {
    width: 72px;
  }
}
@keyframes expanding {
  0% {
    width: 72px;
  }
  100% {
    width: 230px;
  }
}

.wrapper {
  width: 100%;
  min-width: 1134px;
  height: 70px;
  display: flex;
  .appQr {
    width: 140px;
    height: 140px;
    background-color: #f9f9f9;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    position: absolute;
    right: 20px;
    top: 60px;
    z-index: 11;
    img {
      width: 110px;
      height: 110px;
      display: block;
      margin: 15px auto;
    }
  }
}
.logo {
  transition: width 0.3s ease-in 1 normal forwards;
  .site_logo;
  width: 230px;
  height: 70px;
  background-color: @dark;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 6px 6px 20px 0 rgba(5, 10, 15, 0.2);
  z-index: 1;
  cursor: pointer;
  .name {
    width: 100px;
    margin-left: 20px;
  }
  &.menuFold {
    animation: folding 0.3s ease-in 1 normal forwards;
    background-position: -30% center;
  }

  &.menuExpand {
    animation: expanding 0.3s ease-in 1 normal forwards;
  }

  &.is-UnifiedContentLibrary {
    width: 0 !important;
  }
}
.headline {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #ebf0f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 6px 6px 20px 0 rgba(5, 10, 15, 0.05);
  .left {
    display: flex;
    align-items: center;
    .link {
      display: flex;
      height: 18px;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;
      border-right: 1px solid @dateColor;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-size: 16px;
        color: @sub;
        margin-left: 10px;

        &.newadmin {
          position: relative;

          &:after {
            position: absolute;
            top: -14px;
            right: -28px;
            display: block;
            content: "";
            width: 31px;
            height: 16px;
            background: url("../assets/img/common/newIcon.png") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }
      }
    }
    .link:last-child {
      border-right: none;
    }
  }
  .pageTitle {
    display: flex;
    align-items: center;
    color: @dark;
    font-size: 24px;
    margin-left: 50px;
    font-weight: bold;
  }
  .multiSelect {
    display: flex;
    flex-direction: row;
    align-content: center;
    margin-left: 50px;

    li {
      position: relative;
      width: 96px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 24px;
      color: #829191;
      margin-right: 50px;
      user-select: none;
      cursor: pointer;
      font-weight: bold;

      &.on {
        color: #050f0f;
        &::before {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          content: "";
          width: 96px;
          height: 6px;
          background: #41b48c;
        }
      }

      &.red {
        &::after {
          position: absolute;
          top: 20px;
          right: -13px;
          display: block;
          content: "";
          width: 8px;
          height: 8px;
          background: #ff555a;
          border-radius: 11px;
        }
      }

      &:nth-last-of-type(1) {
        margin-right: 0;
      }
    }
  }
  .statusName {
    display: block;
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    border-radius: 12px;
    font-size: 16px;
    color: #41b48c;
    border: 1px solid #41b48c;
    box-sizing: border-box;
    font-weight: normal;
    margin-left: 10px;
    min-width: 80px;
    text-align: center;

    &.red {
      font-size: 16px;
      color: #ff555a;
      border: 1px solid #ff555a;
      box-sizing: border-box;
    }

    &.yellow {
      font-size: 16px;
      color: #f0c129;
      border: 1px solid #f0c129;
      box-sizing: border-box;
    }
  }
  .searchInput {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 683px;
    height: 40px;
    margin-left: 15px;
    background: rgba(167, 172, 187, 0.2);
    border-radius: 6px;
    overflow: hidden;

    input {
      flex: 1;
      height: 100%;
      background: transparent;
      padding: 0 20px;
      font-size: 14px;
      color: #0b131f;
    }

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 75px;
      height: 40px;
      background: #41b48c;
      user-select: none;
      cursor: pointer;

      img {
        width: 23px;
        height: 22px;
      }
    }
  }

  .centerFilter {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: calc(100% - 400px);

    .filterBtn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-width: 98px;
      height: 40px;
      background: rgba(65, 180, 140, 0.1);
      border-radius: 25px;
      color: #00b789;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      user-select: none;
      cursor: pointer;

      &:hover {
        background: rgba(65, 180, 140, 0.15);
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    height: 100%;
    .user {
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      // padding-right: 20px;
      position: relative;
      .avatar-container {
        position: relative;
        height: 50px;
        width: 50px;
        margin-right: 30px;

        img {
          height: 50px;
          width: 50px;
          border-radius: 100%;
        }
        // &:hover {
        //   .avatar {
        //     display: flex;
        //   }
        // }

        .newAvatar {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 60px;
          left: -50px;
          z-index: 999;
          width: 186px;
          max-height: 356px;
          background: rgba(5, 15, 15, 0.8);
          box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
          border-radius: 4px;
          overflow: hidden;

          .platform {
            display: flex;
            flex-direction: column;
            width: 100%;
            max-height: 234px;
            padding: 12px 0 10px;
            border-bottom: 1px solid rgba(220, 220, 220, 0.15);
            box-sizing: border-box;

            .t {
              font-size: 15px;
              line-height: 21px;
              color: #41b48c;
              padding-left: 20px;
              box-sizing: border-box;
              font-weight: bold;
            }

            ul {
              display: flex;
              flex-direction: column;
              width: 100%;
              flex: 1;
              min-height: 0;
              overflow-y: auto;
              &::-webkit-scrollbar {
                width: 6px;
              }
              &::-webkit-scrollbar-thumb {
                background: rgba(185, 195, 195, 0.5);
                border-radius: 4px;
              }

              li {
                // display: flex;
                // align-items: center;
                width: 100%;
                min-height: 40px;
                line-height: 40px;
                font-size: 13px;
                font-weight: bold;
                color: #b9c3c3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-left: 20px;
                box-sizing: border-box;

                &.on {
                  color: #41b48c;
                }

                &:hover {
                  background: rgba(255, 255, 255, 0.1);
                  color: #ffffff;
                  box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                }
              }
            }
          }

          .setBtn {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex: 1;
            min-height: 0;
            width: 100%;

            ul {
              display: flex;
              flex-direction: column;
              width: 100%;
              height: 100%;
              border-radius: 4px;
              overflow: hidden;
              // background: rgba(5, 15, 15, 0.8);

              li {
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 40px;
                line-height: 40px;
                text-align: center;
                // border-bottom: 1px solid rgba(220, 220, 220, 0.15);
                // box-sizing: border-box;
                padding: 0 20px;
                &:nth-last-of-type(1) {
                  border: none;
                }

                &:hover {
                  background: rgba(255, 255, 255, 0.1);

                  i.materialIcon {
                    display: block;
                    width: 17px;
                    height: 17px;
                    margin-right: 7px;
                    background: url("../assets/img/headline/myMaterialOn.svg")
                      no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                  }

                  i.editIcon {
                    display: block;
                    width: 17px;
                    height: 17px;
                    margin-right: 7px;
                    background: url("../assets/img/headline/myEditOn.svg")
                      no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                  }

                  i.closeIcon {
                    display: block;
                    width: 17px;
                    height: 17px;
                    margin-right: 7px;
                    background: url("../assets/img/headline/closeOn.svg")
                      no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                  }

                  span {
                    font-size: 13px;
                    color: #fff;
                  }
                }

                i.materialIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/myMaterial.svg")
                    no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                i.editIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/myEdit.svg") no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                i.closeIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/close.svg") no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                span {
                  font-size: 13px;
                  color: #b9c3c3;
                }
              }
            }
          }
        }

        .avatar {
          position: absolute;
          top: 60px;
          left: 50%;
          z-index: 99999;
          margin-left: -64px;
          width: 128px;
          height: 130px;
          background-color: transparent;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          ul {
            display: flex;
            flex-direction: column;
            width: 128px;
            height: 120px;
            border-radius: 4px;
            overflow: hidden;
            background: rgba(5, 15, 15, 0.8);

            li {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-bottom: 1px solid rgba(220, 220, 220, 0.15);
              // box-sizing: border-box;
              padding: 0 26px;
              &:nth-last-of-type(1) {
                border: none;
              }

              &:hover {
                background: rgba(255, 255, 255, 0.1);

                i.materialIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/myMaterialOn.svg")
                    no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                i.editIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/myEditOn.svg")
                    no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                i.closeIcon {
                  display: block;
                  width: 17px;
                  height: 17px;
                  margin-right: 7px;
                  background: url("../assets/img/headline/closeOn.svg")
                    no-repeat;
                  background-size: 100% 100%;
                  background-position: center center;
                }

                span {
                  font-size: 13px;
                  color: #fff;
                }
              }

              i.materialIcon {
                display: block;
                width: 17px;
                height: 17px;
                margin-right: 7px;
                background: url("../assets/img/headline/myMaterial.svg")
                  no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }

              i.editIcon {
                display: block;
                width: 17px;
                height: 17px;
                margin-right: 7px;
                background: url("../assets/img/headline/myEdit.svg") no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }

              i.closeIcon {
                display: block;
                width: 17px;
                height: 17px;
                margin-right: 7px;
                background: url("../assets/img/headline/close.svg") no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }

              span {
                font-size: 13px;
                color: #b9c3c3;
              }
            }
          }
        }
      }
      .upload-container {
        position: relative;
        width: 30px;
        height: 30px;
        margin-right: 30px;

        &:hover {
          i {
            display: block;
            width: 30px;
            height: 30px;
            background: url("../assets/img/headline/uploadOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          // .upload {
          //   display: flex;
          // }
        }

        i {
          display: block;
          width: 30px;
          height: 30px;
          background: url("../assets/img/headline/upload.svg") no-repeat;
          background-position: center center;
          background-size: 100% 100%;

          &.on {
            display: block;
            width: 30px;
            height: 30px;
            background: url("../assets/img/headline/uploadOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }

        .upload {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          position: absolute;
          top: 20px;
          left: 50%;
          margin-left: -74px;
          width: 148px;
          z-index: 99999;
          // height: 180px;

          & > div {
            height: 20px;
          }

          ul {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 100%;
            // height: 160px;
            background: rgba(5, 15, 15, 0.8);
            border-radius: 4px;
            box-sizing: border-box;

            li {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 40px;
              border-bottom: 1px solid rgba(220, 220, 220, 0.15);
              box-sizing: border-box;

              &:nth-last-of-type(1) {
                border: none;
              }

              &:hover {
                background: rgba(255, 255, 255, 0.1);

                i.interviewIcon {
                  display: block;
                  width: 22px;
                  height: 22px;
                  background: url("../assets/img/headline/interviewOn.svg")
                    no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                i.littleUpload,
                i.uploadIcon {
                  display: block;
                  width: 17px;
                  height: 22px;
                  background: url("../assets/img/headline/littleUploadOn.svg")
                    no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }
                
                i.addreport,
                i.reportIcon {
                  display: block;
                  width: 16px;
                  height: 16px;
                  background: url("../assets/img/headline/reportOn.svg")
                    no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }

                i.publicIcon {
                  display: block;
                  width: 18px;
                  height: 18px;
                  background: url("../assets/img/headline/publicOn.svg")
                    no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }

                i.newMediaPublicIcon {
                  display: block;
                  width: 18px;
                  height: 18px;
                  background: url("../assets/img/headline/newMediaIconOn.svg")
                    no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                  margin-right: 10px;
                }
                

                span {
                  font-size: 13px;
                  color: #fff;
                }
              }

              i.interviewIcon {
                display: block;
                width: 22px;
                height: 22px;
                background: url("../assets/img/headline/interview.svg")
                  no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              i.littleUpload,
              i.uploadIcon {
                display: block;
                width: 17px;
                height: 22px;
                background: url("../assets/img/headline/littleUpload.svg")
                  no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              i.addreport,
              i.reportIcon {
                display: block;
                width: 16px;
                height: 16px;
                background: url("../assets/img/headline/report.svg") no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              i.publicIcon {
                display: block;
                width: 18px;
                height: 18px;
                background: url("../assets/img/headline/public.svg") no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              i.newMediaPublicIcon {
                display: block;
                width: 18px;
                height: 18px;
                background: url("../assets/img/headline/newMediaIcon.svg")
                  no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 10px;
              }

              span {
                font-size: 13px;
                color: #b9c3c3;
              }
            }
          }
        }
      }
      .storage-container {
        position: relative;
        width: 28px;
        height: 28px;
        margin-right: 30px;

        &:hover {
          & > i {
            display: block;
            width: 28px;
            height: 28px;
            background: url("../assets/img/headline/storageOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          // .storage {
          //   display: flex;
          // }
        }

        & > span {
          position: absolute;
          display: block;
          background: #ff555a;
          font-size: 14px;
          color: #fff;
          text-align: center;

          &.small {
            width: 18px;
            height: 18px;
            line-height: 18px;
            border-radius: 50%;
            top: -2px;
            right: -12px;
          }

          &.middle {
            width: 22px;
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
            top: -2px;
            right: -13px;
          }

          &.big {
            width: 22px;
            height: 18px;
            line-height: 10px;
            border-radius: 9px;
            top: -2px;
            right: -13px;
          }

          &.on {
            display: none;
          }
        }

        & > i {
          display: block;
          width: 28px;
          height: 28px;
          background: url("../assets/img/headline/storage.svg") no-repeat;
          background-position: center center;
          background-size: 100% 100%;

          &.on {
            display: block;
            width: 28px;
            height: 28px;
            background: url("../assets/img/headline/storageOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }

        .storage {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          position: absolute;
          top: 21px;
          right: -60px;
          z-index: 99999;
          width: 404px;
          height: 400px;
          background: transparent;

          & > div {
            display: flex;
            flex-direction: column;
            width: 404px;
            height: 380px;
            border-radius: 4px;
            background: rgba(5, 15, 15, 0.8);
            overflow: hidden;

            .title {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 45.5px;
              padding: 0 12px 0 20px;
              border-bottom: 1px solid rgba(220, 220, 220, 0.15);
              box-sizing: border-box;
              p {
                font-size: 16px;
                color: #fff;

                font-family: PingFang-SC-Bold, PingFang-SC;
                font-weight: bold;

                span {
                  font-size: 14px;
                  color: #b9c3c3;
                }
              }

              span {
                font-size: 13px;
                color: @green;
                user-select: none;
                cursor: pointer;
              }
            }

            .content {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              height: 280px;
              // padding: 11px 0;
              box-sizing: border-box;
              overflow-y: auto;

              &::-webkit-scrollbar {
                width: 4px;
              }
              &::-webkit-scrollbar-thumb {
                background: rgba(#dcdcdc, 0.3);
                border-radius: 4px;
              }
            }

            .empty {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 280px;

              p {
                font-size: 14px;
                line-height: 20px;
                color: #b9c3c3;
                font-weight: 500;
                margin-top: 14px;
              }
            }

            ul {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              // height: 280px;
              padding: 11px 0;
              box-sizing: border-box;
              // overflow-y: auto;

              li {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 364px;
                margin-bottom: 12.5px;

                &:hover {
                  .info {
                    p {
                      color: #41b48c;
                    }
                  }
                }

                &.lineOn {
                  border-top: 1px solid #41b48c;
                  border-bottom: 1px solid #41b48c;
                  box-sizing: border-box;
                }

                &:nth-last-of-type(1) {
                  margin-bottom: 0;
                }

                & > i {
                  width: 16px;
                  height: 16px;
                  border-radius: 2px;
                  border: 1px solid #b9c3c3;
                  box-sizing: border-box;
                  overflow: hidden;

                  &.op {
                    border: 1px solid rgba(185, 195, 195, 0.2);
                  }

                  &.on {
                    position: relative;
                    background: @green;
                    border: 1px solid @green;
                    box-sizing: border-box;

                    &:after {
                      display: block;
                      content: "";
                      position: absolute;
                      top: 2.5px;
                      left: 0px;
                      // top: 50%;
                      // left: 50%;
                      // margin-left: -7px;
                      // margin-top: -5.5px;
                      width: 14px;
                      height: 11px;
                      background: url("../assets/img/headline/access.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }
                  }
                }

                & > div {
                  display: flex;
                  flex-direction: row;
                  width: 296px;
                  padding-bottom: 11px;
                  border-bottom: 1px solid rgba(220, 220, 220, 0.15);
                  box-sizing: border-box;

                  .bg {
                    position: relative;
                    min-width: 80px;
                    min-height: 45px;
                    width: 80px;
                    height: 45px;
                    border-radius: 2px;
                    overflow: hidden;
                    margin-right: 16px;
                    background-repeat: no-repeat;
                    background-position: center center;
                    // background-size: 100% 100%;
                    background-size: cover;

                    .play {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      margin-left: -6px;
                      margin-top: -7.5px;
                      display: block;
                      width: 12px;
                      height: 15px;
                      background: url("../assets/img/headline/play.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }

                    .useMask {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      margin-left: -40px;
                      margin-top: -22.5px;
                      display: block;
                      width: 80px;
                      height: 45px;
                      background: rgba(0, 0, 0, 0.7);

                      &:hover {
                        .grey {
                          display: none;
                        }

                        .green {
                          display: block;
                        }
                      }

                      img {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 20px;
                        height: 20px;
                        margin-top: -10px;
                        margin-left: -10px;
                        animation: rotate 2s linear infinite;
                      }

                      .line {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 2px;
                        background: #41b48c;
                      }

                      p {
                        font-size: 12px;
                        line-height: 45px;
                        text-align: center;
                        color: #b9c3c3;
                        font-weight: bold;

                        &.green {
                          display: none;
                          color: #41b48c;
                        }
                      }
                    }
                  }

                  .info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 200px;
                    font-weight: bold;

                    p {
                      font-size: 14px;
                      line-height: 18px;
                      color: #fff;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;

                      &:hover {
                        color: @green;
                      }
                    }

                    i.video {
                      display: block;
                      width: 23px;
                      height: 18px;
                      background: url("../assets/img/headline/videoGreen.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }

                    i.voice {
                      display: block;
                      width: 23px;
                      height: 18px;
                      background: url("../assets/img/headline/voiceGreen.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }

                    i.pic {
                      display: block;
                      width: 23px;
                      height: 18px;
                      background: url("../assets/img/headline/picGreen.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }
                  }
                }
              }
            }

            .bottom {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 55px;
              background: rgba(255, 255, 255, 0.1);
              border-top: 1px solid rgba(220, 220, 220, 0.15);
              padding: 0 20px;
              box-sizing: border-box;

              .left-container {
                display: flex;
                flex-direction: row;
                align-items: center;
              }

              .left-container {
                display: flex;
                flex-direction: row;
                align-items: center;

                & > i {
                  display: block;
                  width: 16px;
                  height: 16px;
                  border-radius: 2px;
                  border: 1px solid #b9c3c3;
                  box-sizing: border-box;
                  overflow: hidden;
                  margin-right: 8px;

                  &.on {
                    position: relative;
                    background: @green;
                    border: 1px solid @green;
                    box-sizing: border-box;

                    &:after {
                      display: block;
                      content: "";
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      margin-left: -7px;
                      margin-top: -5.5px;
                      width: 14px;
                      height: 11px;
                      background: url("../assets/img/headline/access.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                    }
                  }
                }

                span {
                  font-size: 14px;
                  color: #fff;
                  font-weight: bold;
                }
              }

              .right-container {
                display: flex;
                flex-direction: row;
                align-items: center;

                p {
                  width: 70px;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  border-radius: 4px;
                  background: @green;
                  font-size: 14px;
                  color: #fff;
                  font-weight: bold;

                  &:nth-of-type(1) {
                    margin-right: 10px;
                  }

                  &.grey {
                    background-color: #6d7c7c;
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
      }
      .message-container {
        position: relative;
        width: 24px;
        height: 24px;
        margin-right: 30px;

        .short {
          width: 152px !important;
        }

        &:hover {
          & > i {
            display: block;
            width: 24px;
            height: 24px;
            background: url("../assets/img/headline/messageOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          // .message {
          //   display: flex;
          // }
        }

        & > span {
          position: absolute;
          top: -2px;
          right: -2px;
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 11px;
          background: #ff555a;

          &.on {
            display: none;
          }
        }

        & > i {
          display: block;
          width: 24px;
          height: 24px;
          background: url("../assets/img/headline/message.svg") no-repeat;
          background-position: center center;
          background-size: 100% 100%;

          &.on {
            display: block;
            width: 24px;
            height: 24px;
            background: url("../assets/img/headline/messageOn.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }

        .message {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          position: absolute;
          top: 24px;
          right: -60px;
          z-index: 99999;
          width: 404px;
          height: 300px;
          // min-height: 23px;
          background: transparent;

          & > p {
            width: 100%;
            height: 23px;
          }

          .empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
            min-height: 0;

            p {
              font-size: 14px;
              line-height: 20px;
              color: #b9c3c3;
              font-weight: 500;
              margin-top: 14px;
            }
          }

          & > div {
            display: flex;
            flex-direction: column;
            border-radius: 4px;
            background: rgba(5, 15, 15, 0.8);
            width: 100%;
            height: 100%;
            padding: 14px 0px 20px 0px;
            box-sizing: border-box;
            // overflow-y: auto;
            overflow: hidden;

            & > .title {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;
              padding: 0 20px 10px;
              border-bottom: 1px solid rgba(220, 220, 220, 0.15);
              box-sizing: border-box;

              .left {
                font-size: 16px;
                line-height: 22px;
                color: #ffffff;
              }

              .right {
                font-size: 14px;
                line-height: 20px;
                color: #b9c3c3;
                user-select: none;
                cursor: pointer;
              }
            }

            & > div.msgContent {
              width: 100%;
              height: 100%;
              overflow-y: auto;
              // padding-right: 10px;
              padding: 0 20px;
              box-sizing: border-box;

              &::-webkit-scrollbar {
                width: 4px;
              }
              &::-webkit-scrollbar-thumb {
                background: rgba(#dcdcdc, 0.3);
                border-radius: 4px;
              }
            }
          }

          ul {
            display: flex;
            flex-direction: column;
            width: 100%;
            // height: 100%;
            // padding: 20px;
            box-sizing: border-box;

            li {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin-bottom: 22px;
              align-items: center;
              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              &:hover {
                .title {
                  color: @green;
                }
              }

              & > div {
                display: flex;
                flex-direction: row;
                align-items: center;

                .type {
                  width: 70px;
                  height: 20px;
                  line-height: 18px;

                  text-align: center;
                  border-radius: 10px;
                  border: 1px solid @green;
                  font-size: 13px;
                  color: @green;
                  box-sizing: border-box;
                  margin-right: 10px;
                }

                .title {
                  width: 216px;
                  font-size: 14px;
                  color: #fff;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .status {
                font-size: 14px;
                color: #b9c3c3;

                &.error {
                  color: #ff555a;
                }
              }
            }
          }
        }

        .new-message {
          position: absolute;
          top: 24px;
          right: -60px;
          z-index: 99999;
          display: flex;
          flex-direction: column;
          width: 546px;
          height: 500px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f1f1f5;

          &-title {
            padding: 20px;
            font-weight: 500;
            font-size: 24px;
            color: #050f0f;
            line-height: 33px;
          }
        }
      }

      .subscribe-container {
        position: relative;
        width: 24px;
        height: 24px;
        margin-right: 30px;

        & > span {
          position: absolute;
          top: -2px;
          right: -2px;
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 11px;
          background: #ff555a;

          &.on {
            display: none;
          }
        }

        & > i {
          display: block;
          width: 24px;
          height: 24px;
          background: url("../assets/img/headline/subscribe.png") no-repeat;
          background-position: center center;
          background-size: 100% 100%;

          &.on {
            display: block;
            width: 24px;
            height: 24px;
            background: url("../assets/img/headline/subscribeOn.png") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }

        .subscribe-content {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 48px;
          right: -40px;
          z-index: 10;
          width: 404px;
          height: 514px;
          background: rgba(5, 15, 15, 0.8);
          border-radius: 4px;
          padding: 14px 0px;
          box-sizing: border-box;

          .title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 10px;
            border-bottom: 1px solid rgba(220, 220, 220, 0.15);
            box-sizing: border-box;

            .left {
              font-size: 16px;
              line-height: 22px;
              color: #ffffff;
              font-weight: bold;
            }

            .right {
              display: flex;
              flex-direction: row;
              align-items: center;

              span {
                display: block;
                font-size: 14px;
                line-height: 20px;
                color: #b9c3c3;
                margin-right: 6px;
              }

              div {
                display: flex;
                align-items: center;
                width: 44px;
                height: 22px;
                background: #41b48c;
                border-radius: 11px;
                margin-left: 10px;
                user-select: none;
                cursor: pointer;

                &.un {
                  background: #ced3d7;

                  i {
                    margin-left: 2px;
                    transition: margin-left 0.3s;
                  }
                }

                i {
                  display: block;
                  width: 18px;
                  height: 18px;
                  background: #ffffff;
                  border-radius: 50%;
                  margin-left: 24px;
                  transition: margin-left 0.3s;
                }
              }
            }
          }

          .content {
            flex: 1;
            padding: 0 20px;
            box-sizing: border-box;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 6px;
            }
            &::-webkit-scrollbar-thumb {
              background: rgba(185, 195, 195, 0.5);
              border-radius: 2px;
            }

            ul {
              display: flex;
              flex-direction: column;

              li {
                display: flex;
                flex-direction: column;
                padding: 12px 0;
                font-weight: bold;
                border-bottom: 1px solid rgba(220, 220, 220, 0.15);
                box-sizing: border-box;

                &:hover {
                  .t {
                    color: #41b48c;
                  }
                }

                .t {
                  font-size: 14px;
                  line-height: 20px;
                  color: #ffffff;
                  margin-bottom: 4px;
                }

                .i {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  font-size: 12px;
                  line-height: 17px;
                  color: #b9c3c3;

                  .time {
                    display: block;
                    margin-right: 20px;
                  }
                }
              }
            }
          }
        }
      }

      .info {
        .name {
          font-size: 18px;
          color: @dark;
          font-weight: bold;
        }
        .sys {
          color: @dateColor;
          font-size: 12px;
          font-family: Arial, sans-serif;
          font-weight: bold;
        }
      }
      .arrow {
        margin-left: 8px;
      }
      .menu {
        width: 246px;
        background-color: @dark;
        box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
        border-radius: 0 0 4px 4px;
        top: 70px;
        position: absolute;
        z-index: 10;
        left: 0;
        .content {
          // padding: 0 20px;
          .item {
            color: @dateColor;
            font-size: 13px;
            // height: 40px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(220, 220, 220, 0.2);
            .sysname {
              height: auto;
              width: 74px;
              padding: 0 0 0 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .sys {
              .numberFont;
              width: 54px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              flex-shrink: 0;
              height: 16px;
              line-height: 16px;
              padding: 0 6px;
              margin-right: 10px;
              border-radius: 100px;
              background-color: @sub;
              color: @dark;
              box-sizing: border-box;
            }
            .dep {
              flex: 1;
              overflow: hidden;
              &:hover {
                background-color: @dark;
              }
            }
            .role {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 40px;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 20px 0 10px;
              &:hover {
                background-color: rgba(255, 255, 255, 0.1);
              }
            }
          }
          &:hover {
            // background-color: rgba(255, 255, 255, 0.1);
          }
        }
        .content:last-child {
          .item {
            border-bottom: none;
          }
        }
        .handle {
          height: 40px;
          display: flex;
          .btn {
            color: @dateColor;
            font-size: 13px;
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              margin-right: 10px;
            }
          }
          .quit {
            background-color: rgba(255, 255, 255, 0.1);
            color: #fff;
          }
        }
      }
    }
    .seprator {
      width: 2px;
      height: 16px;
      background-color: rgba(151, 151, 151, 0.2);
    }
    .help {
      display: flex;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;
      .app {
        margin: 0 20px 0 10px;
        font-size: 16px;
        color: #829191;
      }
    }
  }
  &.is-UnifiedContentLibrary {
    .pageTitle {
      display: none;
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.headline-unified-content-library {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 40px;
  .unified-back {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    cursor: pointer;
    img {
      width: 21px;
      height: 19px;
    }
  }
  .unified-title {
    flex: 1;
    overflow: hidden;
    padding: 0 24px;
    font-weight: 500;
    font-size: 20px;
    color: #050f0f;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .unified-operate {
    display: flex;
    align-items: center;
    &-op,
    &-jovone,
    &-download {
      width: 24px;
      height: 24px;
      background-image: url("~@/assets/img/headline/unified-download.svg");
      background-repeat: no-repeat;
      background-position: center center;
      cursor: pointer;
      margin-right: 32px;
    }
    &-jovone {
      background-image: url("~@/assets/img/headline/unified-jovone.svg");
      margin-right: 28px;
    }

    &-op {
      position: relative;
      width: 28px;
      height: 28px;
      background-image: url("~@/assets/img/headline/unified-operate.svg");
      margin-right: 20px;
      transform: rotate(90deg);
    }
  }
}

.unifiedContentLibraryNewly {
  position: relative;
  z-index: 100000;
}
</style>

<style>
.wp {
  word-break: break-all;
}
</style>
